export default "<div [id]=\"id\" class=\"view\">\n  <ng-content></ng-content>\n</div>\n"